import React, { useState } from "react";
import { Pagination } from "react-bootstrap";
import { FaGavel, FaCalendarAlt } from "react-icons/fa";
import { GoStopwatch } from "react-icons/go";
import { LuAlarmClockCheck } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import SidebarFilters from "./VehicleFinder/SidebarFilters";

const VehicleIaaIAndCopart = ({
  vehicles,
  totalItems,
  page,
  setPage,
  size,
}) => {
  const navigate = useNavigate();
  const [favoriteVehicles, setFavoriteVehicles] = useState([]);
  const totalPages = Math.ceil(totalItems / size);
  const [dataVehicle, setDataVehicle] = useState(vehicles || []);
  const [tabFilter, setTabFilter] = useState("current")
  const now = Date.now();

  const headerStyle = {
    backgroundColor: "#333",
    color: "#fff",
    textAlign: "center",
  };

  const toggleFavorite = (vehicleId) => {
    setFavoriteVehicles((prevFavorites) => {
      if (prevFavorites.includes(vehicleId)) {
        return prevFavorites.filter((id) => id !== vehicleId);
      } else {
        return [...prevFavorites, vehicleId];
      }
    });
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-PK", {
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getAuctionStatus = (vehicle) => {
    const start = new Date(vehicle?.auction_date).getTime();
    const end = vehicle?.timed_auction_close_date
      ? new Date(vehicle.timed_auction_close_date).getTime()
      : null;

    if (now < start) return "upcoming";
    if (end && now > end) return "archived";
    return "live";
  };

  const getTimeLeft = (startTime) => {
    const diff = startTime - now;
    if (diff <= 0) return "Starting soon";
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    return `${days}d ${hours}h ${minutes}m left`;
  };

  const getFilteredVehicles = () => {
    return dataVehicle?.filter((vehicle) => {
      const status = getAuctionStatus(vehicle);
      if (tabFilter === "current") {
        return status === "live" || status === "upcoming";
      }
      if (tabFilter === "archived") {
        return status === "archived";
      }
      return true;
    });
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-md-3">
          <SidebarFilters vehicles={vehicles} setDataVehicle={setDataVehicle} />
        </div>

        <div className="col-md-9">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 style={{ fontWeight: "bold", color: "#333" }}>
              {totalItems?.toLocaleString()}+ Pure Sale for Sale
            </h3>
            <div class="d-flex flex-wrap gap-2">
              {
                tabFilter === "current" ?
                  <button onClick={() => setTabFilter("archived")} className="btn btn-success shadow-sm px-3 d-flex align-items-center">
                    <GoStopwatch className="me-1" />
                    Archived Auctions
                  </button>
                  : <button onClick={() => setTabFilter("current")} className="btn btn-success shadow-sm px-3 d-flex align-items-center">
                    <FaGavel className="me-1" />
                    Current Auctions
                  </button>
              }
              <button className="btn btn-primary shadow-sm px-3">Export</button>
              <button className="btn btn-info text-white shadow-sm px-3">Save Search</button>
              <button className="btn btn-dark shadow-sm px-3">Classic View</button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={headerStyle}>Image</th>
                  <th style={headerStyle}>Lot Info</th>
                  <th style={headerStyle}>Vehicle Info</th>
                  <th style={headerStyle}>Condition</th>
                  <th style={headerStyle}>Sale Info</th>
                  <th style={headerStyle}>Bids</th>
                </tr>
              </thead>
              <tbody>
                {
                  getFilteredVehicles()?.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No vehicles found
                      </td>
                    </tr>
                  ) :
                    getFilteredVehicles()?.map((vehicle) => {
                      const status = getAuctionStatus(vehicle);
                      const startTime = new Date(vehicle?.auction_date).getTime();
                      return (

                        <tr key={vehicle?.id}>
                          <td>
                            <img
                              src={vehicle?.link_img_hd?.[0]}
                              alt={vehicle?.lotInfo}
                              className="img-fluid"
                              style={{ width: "150px", borderRadius: "4px" }}
                            />
                          </td>
                          <td>
                            <div>
                              <strong>{vehicle?.lotInfo}</strong>
                            </div>
                            <div>Lot #: {vehicle?.lot_id}</div>
                            <button
                              className="btn btn-link text-primary"
                              onClick={() => toggleFavorite(vehicle?.id)}
                            >
                              <i
                                className={`fa-solid fa-heart fa-2xl ${favoriteVehicles.includes(vehicle?.id)
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{
                                  color: favoriteVehicles.includes(vehicle?.id)
                                    ? "#e40707"
                                    : "black",
                                }}
                              ></i>
                            </button>
                          </td>
                          <td>
                            <div>Odometer: {vehicle?.odometer}</div>
                            <div>
                              Estimated Value: {vehicle?.estimatedValue || "N/N"}
                            </div>
                          </td>
                          <td>
                            <div>{vehicle?.title}</div>
                            <div>{vehicle?.damage_pr}</div>
                            <div>{vehicle?.keys}</div>
                          </td>
                          <td>
                            <div>{vehicle?.location}</div>
                            <div>{vehicle?.auction_type}</div>
                          </td>
                          <td>
                            <div
                              style={{
                                padding: "14px",
                                border: "1px solid #e5e5e5",
                                borderRadius: "10px",
                                background: "#fff",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                minWidth: "220px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "15px",
                                  marginBottom: "10px",
                                  color: "#444",
                                  gap: "6px",
                                }}
                              >
                                <FaCalendarAlt />
                                {formatDate(vehicle?.auction_date)}
                              </div>

                              {status === "live" && (
                                <>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      padding: "7px",
                                      background: "#f8f9fa",
                                      borderRadius: "8px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ fontSize: "15px", color: "#777" }}>Current Bid</div>
                                    <div style={{ fontWeight: "700", fontSize: "18px" }}>
                                      {vehicle?.current_bid ? `$${vehicle.current_bid}` : "$0"}
                                    </div>
                                  </div>

                                  <button
                                    title="Bidding not avialable"
                                    style={{
                                      width: "100%",
                                      padding: "8px",
                                      border: "2px solid green",
                                      borderRadius: "8px",
                                      background: "white",
                                      color: "green",
                                      fontWeight: "600",
                                      cursor: "text",
                                    }}
                                  >
                                    <span style={{ color: "green" }}>&#9679;</span> Live
                                  </button>
                                </>
                              )}

                              {status === "upcoming" && (
                                <>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginBottom: "10px",
                                      color: "#198754",
                                      fontSize: "15px",
                                      fontWeight: "600",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <LuAlarmClockCheck />
                                    {getTimeLeft(startTime)}
                                  </div>

                                  <div
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      background: "#f8f9fa",
                                      borderRadius: "8px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ fontSize: "15px", color: "#777" }}>Current Bid</div>
                                    <div style={{ fontWeight: "700", fontSize: "18px" }}>
                                      {vehicle?.current_bid ? `$${vehicle.current_bid}` : "$0"}
                                    </div>
                                  </div>

                                  <button
                                    title="Bidding Available"
                                    disabled
                                    style={{
                                      width: "100%",
                                      padding: "8px",
                                      border: "2px solid green",
                                      borderRadius: "8px",
                                      background: "green",
                                      color: "white",
                                      fontWeight: "600",
                                      cursor: "text",
                                    }}
                                  >
                                    Opened auction
                                  </button>
                                </>
                              )}

                              {status === "archived" && (
                                <>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      background: "#f8d7da",
                                      borderRadius: "8px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ fontSize: "12px", color: "#777" }}>Final Bid</div>
                                    <div style={{ fontWeight: "700", fontSize: "16px" }}>
                                      {vehicle?.current_bid ? `$${vehicle.current_bid}` : "--"}
                                    </div>
                                  </div>

                                  {vehicle?.is_buynow && (
                                    <div
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        marginBottom: "8px",
                                        color: "#dc3545",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Sold by Buy Now
                                    </div>
                                  )}

                                  <button
                                    title="Bidding not avialable"
                                    disabled
                                    style={{
                                      width: "100%",
                                      padding: "8px",
                                      border: "none",
                                      borderRadius: "8px",
                                      background: "#6c757d",
                                      color: "#fff",
                                      fontWeight: "600",
                                      cursor: "not-allowed",
                                    }}
                                  >
                                    Archived Auction
                                  </button>
                                </>
                              )}

                              <button
                                onClick={() =>
                                  navigate(
                                    `/detail/${vehicle?.id}`,
                                    { state: { vehicle } },
                                    window.scrollTo(0, 0)
                                  )
                                }
                                style={{
                                  width: "100%",
                                  marginTop: "10px",
                                  padding: "9px",
                                  border: "none",
                                  borderRadius: "8px",
                                  background: "#ffe0b2",
                                  color: "#8a4b00",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                }}
                              >
                                View Details
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center my-4">
            <Pagination>

              <Pagination.Prev
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
              />
              {[...Array(Math.min(totalPages, 5))].map((_, idx) => {
                const pageNumber = idx + Math.max(1, page - 2);
                return (
                  pageNumber <= totalPages && (
                    <Pagination.Item
                      key={pageNumber}
                      active={page === pageNumber}
                      onClick={() => setPage(pageNumber)}
                    >
                      {pageNumber}
                    </Pagination.Item>
                  )
                );
              })}
              <Pagination.Next
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

export default VehicleIaaIAndCopart;